import { useMemo } from "react";
import { AvatarStackItem } from "~/pages/manifold-nextgen/components/AvatarStack";
import { buildExpandedAccess } from "~/pages/manifold-nextgen/components/share/AccessDetailsView";
import {
  type AccessLevelOption,
  type ShareCollaborators,
} from "~/pages/manifold-nextgen/components/share/types";

/**
 * Resolves the owners of a shared entity (project / dataset / agent) into
 * `AvatarStackItem`s for the overview "Owners" tile. `ownerRole` is the role
 * string that counts as ownership for that entity (e.g. `ProjectAccessLevel.OWNER`,
 * `DatasetAccessLevel.OWNER`, `AgentAccessLevel.OWNER`).
 */
export const useOwners = (
  collaborators: ShareCollaborators | undefined,
  accessLevels: Record<string, AccessLevelOption>,
  ownerRole: string
): AvatarStackItem[] =>
  useMemo(() => {
    if (!collaborators) {
      return [];
    }
    return buildExpandedAccess(collaborators.users, collaborators.groups, accessLevels)
      .filter((person) => person.effectiveRole === ownerRole)
      .map((person) => ({ id: person.email, name: person.label, imageUrl: person.avatarUrl }));
  }, [collaborators, accessLevels, ownerRole]);
